import Button from "../../../../components/common/ui/Button";
import { history } from "../../../../_helpers/history";
import TextInput from "../../../../components/common/ui/Inputs/TextInput";
import SelectInput from "../../../../components/common/ui/Inputs/SelectInput";
import RadioInput from "../../../../components/common/ui/Inputs/RadioInput";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState, useRef } from "react";
import TextAreaInput from "../../../../components/common/ui/Inputs/TextAreaInput";
import { committeeActions } from "../../../../_store/committee.slice";
import { masterActions } from "../../../../_store/master.slice";
import committeeSchema from "../../../../validation/Admin/CommitteeSchema";
import { showToastNotification } from "../../../../components/common/ui/NotificationModal/ToastNotication";
import { useLocation } from "react-router-dom";
import MultiSelectDropdown from "../../../../components/common/ui/Inputs/MultiSelectDropdown";
import FileInput from "../../../../components/common/ui/Inputs/FileInput";

function CreateOrEditCommittee() {
  const dispatch = useDispatch();
  const location = useLocation();

  const [isPending, setIsPending] = useState(false);
  const [errorMessage, setErrorMessage] = useState({});
  const [committeeChairList, setCommitteeChairList] = useState([]);
  const { committeeForm, getCommitteeByIDResponse } = useSelector(
    (x) => x?.committee
  );
  const { ActiveStatus, TrueOrFalse } = useSelector((x) => x?.dropDown);
  const { getAllActiveUsersResponse } = useSelector((x) => x?.master);

  const committeeID = location?.state ? location?.state?.committeeID : 0;
  // const committeeAdmin = location?.state ? location?.state?.committeeAdmin : {};
  const [committeeAdmin, setCommitteeAdmin] = useState({});
  const fileInputRef = useRef(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [previewImage, setPreviewImage] = useState("");

  useEffect(() => {
    if (committeeID === 0) {
      dispatch(committeeActions.resetCommitteeForm());
      setSelectedFile(null);
      setPreviewImage("");
      return;
    }

    dispatch(committeeActions.getCommitteeByID(committeeID))
      .then((result) => {
        const response = { ...result?.payload?.data };
        dispatch(committeeActions.updateCommitteeForm(response));
        if (response?.committeeImage) {
          setPreviewImage(
            `${process.env.REACT_APP_API_IMAGE_URL || ""}${response.committeeImage}`
          );
        } else {
          setPreviewImage("");
        }
        if (
          (response?.committeeAdmin?.fullName !== undefined ||
            response?.committeeAdmin?.fullName !== "undefined") &&
          (response?.committeeAdmin?._id !== undefined ||
            response?.committeeAdmin?._id !== "undefined") &&
          (response?.committeeAdmin?.role !== undefined ||
            response?.committeeAdmin?.role !== "undefined")
          // response?.committeeAdmin?._id !== undefined &&
          // response?.committeeAdmin?.role !== undefined
        ) {
          setCommitteeAdmin({
            label: response?.committeeAdmin?.fullName,
            value: response?.committeeAdmin?._id,
            role: response?.committeeAdmin?.role,
          });
        }
      })
      .catch((err) => {
        showToastNotification("Failed to get Committee Details", "error");
      });
  }, [committeeID, dispatch]);

  useEffect(() => {
    getUserList();
  }, [committeeAdmin]);

  const getUserList = () => {
    dispatch(masterActions?.getAllActiveUsers())
      .then((result) => {
        const committeeChairList = [...result?.payload?.data?.formattedUsers];

        // const updatedArr = [
        //   ...committeeForm.committeeAdmin
        //     .filter((admin) => admin?.role !== 3)
        //     .map((admin) => ({
        //       label: `${admin.fullName} (${admin.email})`,
        //       value: admin._id,
        //     })),
        //   ...committeeChairList,
        // ];

        setCommitteeChairList(committeeChairList);
      })
      .catch((err) => {
        showToastNotification(err?.message, "error");
      });
  };

  const handleChange = (e, select) => {
    const formData = { ...committeeForm };

    if (select) {
      formData[select] = { ...formData[select], _id: e?.value }; // clone & update
      dispatch(committeeActions.updateCommitteeForm(formData));
      return;
    }

    const { name, value, type } = e?.target;
    if (value.startsWith(" ")) return;

    let newValue = value;

    if (name === "committeeName") {
      // Allow only letters, numbers, spaces, hyphens, &, (), ., @
      newValue = value.replace(/[^a-zA-Z0-9\s\-&().@_']/g, "");
    }

    formData[name] =
      type === "radio" ? (newValue === "true" ? true : false) : newValue;
    dispatch(committeeActions.updateCommitteeForm(formData));
  };

  const handleSelectChange = (selectedOptions, fieldName) => {
    const selectedIds = selectedOptions?.map((item) => item.value) || [];

    // Update committeeForm inside Redux
    dispatch(
      committeeActions.updateCommitteeForm({
        ...committeeForm,
        [fieldName]: selectedIds, // updates committeeAdmin as an array of ids
      })
    );

    // setRegisterForm((prevForm) => ({
    //   ...prevForm,
    //   [fieldName]: selectedIds,
    // }));
  };

  const handleFileChange = (e) => {
    const file = e?.target?.files?.[0];
    if (!file) return;

    const allowedTypes = ["image/png", "image/jpeg", "image/jpg"];
    const fileExtension = file.name.split(".").pop().toLowerCase();
    const allowedExtensions = ["png", "jpg", "jpeg"];

    if (
      !allowedTypes.includes(file.type) &&
      !allowedExtensions.includes(fileExtension)
    ) {
      setErrorMessage((prev) => ({
        ...prev,
        committeeImage: "Supports only PNG, JPG, and JPEG images.",
      }));
      if (e.target) e.target.value = "";
      setSelectedFile(null);
      setPreviewImage("");
      return;
    }

    if (file.size > 5 * 1024 * 1024) {
      setErrorMessage((prev) => ({
        ...prev,
        committeeImage: "Image size must not exceed 5MB.",
      }));
      if (e.target) e.target.value = "";
      setSelectedFile(null);
      setPreviewImage("");
      return;
    }

    setErrorMessage((prev) => {
      const newErrors = { ...prev };
      delete newErrors.committeeImage;
      return newErrors;
    });

    setSelectedFile(file);
    setPreviewImage(URL.createObjectURL(file));
  };

  const handleClearImage = () => {
    setSelectedFile(null);
    setPreviewImage("");
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
    dispatch(
      committeeActions.updateCommitteeForm({
        ...committeeForm,
        committeeImage: "",
      })
    );
    setErrorMessage((prev) => {
      const newErrors = { ...prev };
      delete newErrors.committeeImage;
      return newErrors;
    });
  };

  const handleFormSubmit = (e) => {
    setIsPending(true);
    e?.preventDefault();
    console.log(committeeForm);

    const form = { ...committeeForm };
    // form["committeeAdmin"] = committeeForm?.committeeAdmin?._id || "";

    const fileErrors = {};
    if (selectedFile && selectedFile.size > 5 * 1024 * 1024) {
      fileErrors.committeeImage = "Image size must not exceed 5MB.";
    }

    const { error } = committeeSchema(form);
    if (error?.details || Object.keys(fileErrors).length > 0) {
      setIsPending(false);
      const errors = { ...fileErrors };
      if (error?.details) {
        error.details.forEach((e) => {
          const { path } = e;
          errors[path[0]] = e?.message;
        });
      }
      setErrorMessage(errors);
      return;
    }

    setErrorMessage({});

    const formData = new FormData();
    formData.append("committeeName", form.committeeName || "");
    formData.append("committeeDescription", form.committeeDescription || "");
    formData.append("status", form.status);
    formData.append("secretCommittee", form.secretCommittee);
    formData.append("fromName", form.fromName || "");
    formData.append("fromEmail", form.fromEmail || "");

    if (committeeID) {
      formData.append("_id", committeeID);
    }

    if (Array.isArray(form.committeeAdmin)) {
      form.committeeAdmin.forEach((admin) => {
        const adminId = typeof admin === "object" ? admin._id : admin;
        if (adminId) formData.append("committeeAdmin", adminId);
      });
    }

    if (selectedFile) {
      formData.append("committeeImage", selectedFile);
    } else {
      formData.append("committeeImage", form.committeeImage || "");
    }

    //API call after validation
    const resquest = committeeID
      ? dispatch(committeeActions?.updateCommittee(formData))
      : dispatch(committeeActions?.CreateCommittee(formData));
    resquest
      .then((result) => {
        setIsPending(false);
        if (result?.payload?.status === 1) {
          showToastNotification(result?.payload?.message, "success");
          dispatch(committeeActions.resetCommitteeForm());
          history?.navigate("/Admin/Committee", {
            state: { committeeID: 0 },
          });
        } else {
          showToastNotification(
            result?.payload?.message ||
            result?.error?.message ||
            "Failed to save committee",
            "error"
          );
        }
      })
      .catch((err) => {
        showToastNotification("Failed to save committee", "error");
        setIsPending(false);
      });
  };

  const handleFormReset = () => {
    setErrorMessage({});
    setSelectedFile(null);
    setPreviewImage("");
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
    if (committeeID) {
      dispatch(committeeActions.getCommitteeByID(committeeID))
        .then((result) => {
          const data = result?.payload?.data;
          dispatch(committeeActions.updateCommitteeForm(data));
          if (data?.committeeImage) {
            setPreviewImage(
              `${process.env.REACT_APP_API_IMAGE_URL || ""}${data.committeeImage}`
            );
          }
        })
        .catch((err) => {
          showToastNotification("Failed to get Committee Details", "error");
        });
    } else {
      dispatch(committeeActions.resetCommitteeForm());
    }
  };

  // console.log("committeeForm", committeeForm);
  // console.log("committeeChairList", committeeChairList);
  // console.log(committeeForm?.committeeAdmin);

  return (
    <>
      <div className="d-flex justify-content-between align-items-center">
        <h1 className="header-color">Committee</h1>
        <Button
          label="Back"
          status="reset"
          onClick={() => {
            history?.navigate("/Admin/Committee", {
              state: { committeeID: 0 },
            });
            dispatch(committeeActions.resetCommitteeForm());
          }}
        />
      </div>
      <div className="card shadow-sm b-r-all border border-dark-grey mt-3 w-100">
        <h1 className="m-0 search-header-color border-dotted p-3 border-bottom">
          {committeeID ? "Edit " : "Create "}Committee
        </h1>
        <form
          onSubmit={(e) => {
            handleFormSubmit(e);
          }}
          onReset={(e) => {
            handleFormReset(e);
          }}
          className="p-3 row"
        >
          <div className="row mb-4">
            <div className="col-md-4">
              <TextInput
                label="Committee Name"
                placeholder="Committee name"
                name="committeeName"
                id="committeeName"
                handleChange={(e) => handleChange(e)}
                required
                errorMessage={errorMessage}
                value={committeeForm?.committeeName}
                maxLength={60}
              />
            </div>
            <div className="col-md-4">
              {/* <SelectInput
                options={committeeChairList}
                name="committeeAdmin"
                id="committeeAdmin"
                label="Committee Chair"
                required
                handleChange={(e) => handleChange(e, "committeeAdmin")}
                errorMessage={errorMessage}
                value={committeeForm?.committeeAdmin?._id}
              /> */}
              <MultiSelectDropdown
                name="committeeAdmin"
                options={committeeChairList}
                displayValue="label"
                handleChange={(e) => handleSelectChange(e, "committeeAdmin")}
                placeholder="Choose Committee"
                label="Choose Chair"
                required
                errorMessage={errorMessage}
                // selectedValue={
                //   Array.isArray(committeeChairList) &&
                //   Array.isArray(committeeForm?.committeeAdmin)
                //     ? committeeChairList.filter((option) =>
                //         committeeForm.committeeAdmin.includes(option.value)
                //       )
                //     : []
                // }
                // selectedValue={
                //   Array.isArray(committeeChairList) &&
                //   Array.isArray(committeeForm?.committeeAdmin)
                //     ? committeeChairList.filter((option) => {
                //         const selectedIds = committeeForm.committeeAdmin.map(
                //           (item) => (typeof item === "object" ? item._id : item)
                //         );
                //         return selectedIds.includes(option.value);
                //       })
                //     : []
                // }
                selectedValue={
                  Array.isArray(committeeChairList) &&
                    Array.isArray(committeeForm?.committeeAdmin)
                    ? committeeChairList.filter((option) => {
                      const selectedIds = committeeForm.committeeAdmin.map(
                        (item) => (typeof item === "object" ? item._id : item)
                      );
                      return selectedIds.includes(option.value);
                    })
                    : []
                }
              // selectedValue={[{label:"hello",value:"68a5a15d978fc1c6aceece5d"},"68a5a15d978fc1c6aceece60"]}
              />
            </div>
            <div className="col-md-4">
              <RadioInput
                name="status"
                id="status"
                label="Status"
                options={ActiveStatus}
                handleChange={(e) => handleChange(e)}
                selectedValue={committeeForm?.status}
              />
            </div>
            <div className="col-md-4">
              <RadioInput
                name="secretCommittee"
                id="secretCommittee"
                label="Secret Committee"
                options={TrueOrFalse}
                handleChange={(e) => handleChange(e)}
                selectedValue={committeeForm?.secretCommittee}
              />
            </div>
            <div className="col-md-4">
              <TextInput
                label="From Name"
                placeholder="From Name"
                name="fromName"
                id="fromName"
                handleChange={(e) => handleChange(e)}
                required
                errorMessage={errorMessage}
                value={committeeForm?.fromName}
                maxLength={75}
              />
            </div>
            <div className="col-md-4">
              <TextInput
                label="From Email"
                placeholder="From Email"
                name="fromEmail"
                id="fromEmail"
                type="email"
                handleChange={(e) => handleChange(e)}
                required
                errorMessage={errorMessage}
                value={committeeForm?.fromEmail}
                maxLength={100}
              />
            </div>
            <div className="col-md-6 col-lg-4 mt-2">
              <FileInput
                name="committeeImage"
                id="committeeImage"
                label="Committee Logo (PNG, JPG, JPEG only) (Max File Size: 5MB)"
                acceptFormat=".png,.jpg,.jpeg,image/png,image/jpeg"
                handleFileChange={handleFileChange}
                imageURL={previewImage}
                onClearImage={handleClearImage}
                errorMessage={errorMessage}
                ref={fileInputRef}
              />
            </div>
            <div className="col-md-12 mt-2">
              <TextAreaInput
                type="text"
                label="Committee Description"
                placeholder="Committee Description"
                name="committeeDescription"
                id="committeeDescription"
                handleChange={(e) => handleChange(e)}
                // required
                errorMessage={errorMessage}
                value={committeeForm?.committeeDescription}
                maxLength={500}
              />
            </div>
          </div>
          <div className="d-flex justify-content-center align-items-center gap-2">
            <Button
              label={`${committeeID === 0 ? "Submit" : "Update"}`}
              type="submit"
              status="secondary"
              disabled={isPending}
            />
            <Button label="Reset" type="reset" status="reset" />
          </div>
        </form>
      </div>
    </>
  );
}

export default CreateOrEditCommittee;
